// @ts-nocheck
import { useEffect, useState } from 'react';

export const useMediaQ = (minMax, MinMax, isWidth = true) => {
    // use example:
    // * useMediaQ('min', 1024, true); // true if current screen width is larger than 1024px, false otherwise
    // * useMediaQ('max', 1024, false); // true if current screen height is smaller than 1024px, false otherwise
    const innerWidth = typeof window !== 'undefined' && window.innerWidth;
    const [width, setWidth] = useState(innerWidth);

    const innerHeight = typeof window !== 'undefined' && window.innerHeight;
    const [height, setHeight] = useState(innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [setWidth, setHeight]);

    if (minMax === 'min') return isWidth ? width >= MinMax : height >= MinMax;
    return isWidth ? width <= MinMax : height <= MinMax;
};
